<template>
  <div>
    <div class="qiye">
      <!-- <span>通知公告</span> -->
      <!-- 如果有通知 -->
      <ul v-if="subjects.length > 0">
        <li class="qiye_list" v-for="(item, index) in subjects" :key="index">
          <router-link :to="{ path: '/noteDetails', query: { id: item.id } }" class="qiye_list_router">
            <div class="qiye_right">
              <h2>{{ item.title }}</h2>
              <p>{{ item.content }}... </p>
              <span class="date">通知时间：{{ item.created_at | formatDate }}</span> <!-- 假设你有日期字段 -->
            </div>
          </router-link>
        </li>
      </ul>

      <!-- 如果没有通知 -->
      <div v-else class="no-notice">
        <h2>暂无通知</h2>
      </div>

    </div>
    <div class="fenye">
      <ul v-if="subjects.length > 0">
        <li class="fenyehidden"><a v-on:click="setPage(paginator.first)">{{$t("subject.pagination.first")}}</a></li>
        <li v-if="paginator.current > 1"><a v-on:click="setPage(paginator.before)">{{$t("subject.pagination.prev")}}</a></li>
        <li v-if="paginator.current == 1" class="banclick fenyehidden"><a>{{$t("subject.pagination.prev")}}</a></li>
        <!--当前页背景色为蓝色-->
        <li v-for="index in indexs" v-bind:class="{ 'active': paginator.current == index}" :key="index">
          <a v-on:click="setPage(index)">{{ index }}</a>
        </li>
        <li v-if="paginator.current < paginator.total_items"><a v-on:click="setPage(paginator.next)">{{$t("subject.pagination.next")}}</a></li>
        <li v-if="paginator.current == paginator.total_items" class="banclick"><a>{{$t("subject.pagination.next")}}</a></li>
        <li class="fenyehidden"><a v-on:click="setPage(paginator.last)">{{$t("subject.pagination.last")}}</a></li>
        <li class="fenyehidden"><a>{{$t("subject.pagination.all")}} {{ paginator.total_pages }} {{$t("subject.pagination.pages")}} {{ paginator.total_items }} {{$t("subject.pagination.record")}}</a></li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.qiye {
  width: 100%;
  max-width: 800px; /* 限制最大宽度 */
  margin: 0 auto; /* 居中 */
  padding: 20px;
  box-sizing: border-box;
}

.qiye ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.qiye_list {
  width: 95%;
  margin-bottom: 15px; /* 框与框之间的间距 */
  background-color: #fff;
  border: 1px solid #e0e0e0; /* 边框 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 阴影 */
  overflow: hidden; /* 防止内容溢出 */
  transition: box-shadow 0.3s ease;
}

.qiye_list:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 悬停时阴影加深 */
}

.qiye_list_router {
  text-decoration: none; /* 去掉链接下划线 */
  color: inherit; /* 继承父元素颜色 */
  display: block; /* 让链接占满整个 li */
  padding: 15px; /* 内边距 */
}
.qiye_right {
  width: 700px;
}
.qiye_right h2 {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #f80000;
}

.qiye_right p {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.qiye_right .date {
  display: block;
  font-size: 12px;
  color: #999;
}
</style>
<script>
import { formatDate } from '@/assets/js/date.js'
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
    }
  },
  filters: {
    formatDate (time) {
      // let date = new Date(time)
      // return formatDate(date, 'yyyy-MM-dd')
      if (time !== null) {
        let temp = time.split(' ');
        return temp[0];
      }
      return '';
    }
  },
  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)


    // 加载路由参数
    this.getRouteQuery()
    // 请求列表数据
    this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  // 方法属性
  methods: {
    // 获取路由参数
    getRouteQuery: function () {
      if (this.$route.query.page !== undefined) {
        this.paginator.current = this.$route.query.page;
      }
    },

    getSubjects: function () {
      // 请求页面数据
      var order = "id DESC";
      this.axios.get(this.$global.apiUrl.notes, {
        params: {
          page: this.paginator.current,
          limit: this.paginator.limit,
          order: order,

        }
      })
        .then((response) => {
          if (response.data.error.code == 0) {
            this.subjects = response.data.subjects;
            this.paginator = response.data.paginator;
          }
          console.log(this.subjects)
        })
        .catch(() => {
          // console.log(response.data.error.message)
        })
    },

    setPage: function (page) {
      let query = Object.assign({}, this.$route.query, { page: page })
      this.$router.push({ query: query })
    },

    resetPage: function (query) {
      return Object.assign({}, query, { page: 1 })
    },
  },

  // 计算属性
  computed: {
    // 分页
    indexs: function () {
      var left = 1;
      var right = this.paginator.total_pages;
      var ar = [];
      if (this.paginator.total_pages >= 5) {
        //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
        if (this.paginator.current > 3 && this.paginator.current < this.paginator.total_pages - 1) {
          //以4为参考基准，左面加2右边加2
          left = this.paginator.current - 2
          right = this.paginator.current + 2
        } else {
          if (this.paginator.current <= 3) {
            left = 1
            right = 5
          } else {
            right = this.paginator.total_pages
            left = this.paginator.total_pages - 4
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  }
}
</script>